import React, { useRef } from "react";
import { useState, useContext, useEffect } from "react";
import {
  ThemeButtonBGAIDetector,
  ALERT_TIMEOUT,
  STATUS_CHECK_INTERVAL,
} from "../Config";
import { aiImageDetectorContext } from "./AIImageDetectorMain";
import { resizeImageFileForDetection224x224 } from "../Utils";
import { REQUEST_URL } from "../Config";

function AIImageDetector() {
  //file input button reference
  const fileInputRef = useRef(null);

  //alert state
  const [alert, setAlert] = useState({
    type: "success",
    message: "",
    visible: false,
  });

  //get ai detector values
  const { aiImageDetectorValues, setAIImageDetectorValues } = useContext(
    aiImageDetectorContext
  );

  //submit form button clicked state
  const [submitClicked, setSubmitClicked] = useState(false);

  //use effect to handle the submit button click
  useEffect(() => {
    // If the submit button was clicked
    if (submitClicked) {
      //call api to ai detector
      aiImageDetectorAPICall();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitClicked]);

  //check status from status from endpoint
  const checkRunpodJobStatus = async (job_id) => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "STATUS_CHECK_AI_DETECTOR_IMAGE",
        image_data: "",
        job_id: job_id, // can be used for tracking jobs
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //check success
        if (data.success === true) {
          //check status
          if (data.status === "COMPLETED") {
            //hide the spinner
            setSubmitClicked(false);

            //result json
            const result = JSON.parse(data.message);
            // Update the state with the new value
            setAIImageDetectorValues({
              ...aiImageDetectorValues,
              probability: result.probability,
              image_data: result.image_data,
              isLoaded: true,
            });
          } else if (
            data.status === "FAILED" ||
            data.status === "CANCELLED" ||
            data.status === "TIMED_OUT"
          ) {
            //hide the spinner
            setSubmitClicked(false);

            //set alert state to show error
            setAlert({
              type: "danger",
              message:
                "Failed to detect if image is AI generated. Please try again.",
              visible: true,
            });
            //hide alert after 5 seconds
            setTimeout(() => {
              setAlert({ ...alert, visible: false });
            }, ALERT_TIMEOUT);
          } else if (
            data.status === "IN_QUEUE" ||
            data.status === "RUNNING" ||
            data.status === "IN_PROGRESS"
          ) {
            //check api after 10 seconds
            setTimeout(() => {
              //callback
              checkRunpodJobStatus(job_id);
            }, STATUS_CHECK_INTERVAL);
          }
        } else {
          //hide the spinner
          setSubmitClicked(false);
          //scroll to top
          window.scrollTo(0, 0);
          //set alert state to show error
          setAlert({
            type: "danger",
            message:
              data.message ||
              "Failed to detect if image is AI generated. Please try again.",
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);
        }

        console.log("Response Data ai detector:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        //hide the spinner
        setSubmitClicked(false);

        //set alert state to show error
        setAlert({
          type: "danger",
          message:
            "Failed to detect if image is AI generated. Please try again.",
          visible: true,
        });
        //hide alert after 5 seconds
        setTimeout(() => {
          setAlert({ ...alert, visible: false });
        }, ALERT_TIMEOUT);
      });
  };

  //ai image detect from endpoint
  const aiImageDetectorAPICall = async () => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the humanized text from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "AI_DETECTOR_IMAGE",
        image_data: aiImageDetectorValues.image_data,
        mode: 1, //field required. so giving random value
        job_id: null, // can be used for tracking jobs
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //set token in local storage
        localStorage.setItem("access_token", data.token);

        //check if the response is successful
        //and job is send to runpod server
        if (data.success === true) {
          //set job_id
          const job_id = data.job_id;
          //check response from runpod server
          //when ai detection image is completed
          if (
            data.status === "FAILED" ||
            data.status === "CANCELLED" ||
            data.status === "TIMED_OUT" ||
            job_id === null
          ) {
            //hide the spinner
            setSubmitClicked(false);

            //set alert state to show error
            setAlert({
              type: "danger",
              message:
                "Failed to detect if image is AI generated. Please try again.",
              visible: true,
            });
            //hide alert after 5 seconds
            setTimeout(() => {
              setAlert({ ...alert, visible: false });
            }, ALERT_TIMEOUT);
          } else {
            //check status for job_id
            checkRunpodJobStatus(job_id);
          }
        } else {
          //hide the spinner
          setSubmitClicked(false);
          //scroll to top
          window.scrollTo(0, 0);
          //set alert state to show error
          setAlert({
            type: "danger",
            message:
              data.message ||
              "Failed to detect if image is AI generated. Please try again.",
            visible: true,
          });
          //hide alert after 5 seconds
          setTimeout(() => {
            setAlert({ ...alert, visible: false });
          }, ALERT_TIMEOUT);
        }

        console.log("Response Data ai detector image:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
        //hide the spinner
        setSubmitClicked(false);
        //set alert state to show error
        setAlert({
          type: "danger",
          message:
            "Failed to detect if image is AI generated. Please try again. \n" +
            error.message,
          visible: true,
        });

        //hide
        setTimeout(() => {
          //hide alert after 5 seconds
          setAlert({ ...alert, visible: false });
        }, ALERT_TIMEOUT);
      });
  };

  //submit handler for the form
  const onSubmitAIImageDetectorForm = (event) => {
    // Get the textarea value
    event.preventDefault();

    //check
    if (aiImageDetectorValues.formFile === "") {
      //show warning
      //set alert state to show error
      setAlert({
        type: "warning",
        message:
          "No file selected. Please select a valid image. Only .jpg and .png images are supported. Conver images to supported file type.",
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);

      //return
      return;
    }

    //check
    //check
    if (aiImageDetectorValues.image_data === "") {
      //show warning
      //set alert state to show error
      setAlert({
        type: "warning",
        message:
          "Sorry, something went wrong. Can not read image. Please try again with different image.",
        visible: true,
      });
      //hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ ...alert, visible: false });
      }, ALERT_TIMEOUT);

      //return
      return;
    }

    //set the submit clicked state to true
    //can not access the form values directly here
    //as the state is not updated immediately
    //use effect will be called after the state is updated
    setSubmitClicked(true);
  };

  //onvalue change handler for the textarea
  const onChangeAIImageDetectorForm = async (event) => {
    //image
    var image = "";

    //check
    if (event.target.files && event.target.files[0]) {
      //resize image
      try {
        const file = event.target.files[0];
        image = await resizeImageFileForDetection224x224(file);
      } catch (err) {
        console.log(err);
      }
    }

    // Update the state with the new value
    setAIImageDetectorValues({
      ...aiImageDetectorValues,
      [event.target.id]: event.target.value,
      image_data: image,
      isLoaded:
        event.target.id === "formFile" ? false : aiImageDetectorValues.isLoaded,
      probability:
        event.target.id === "formFile" ? 0 : aiImageDetectorValues.probability,
    });
  };

  return (
    <section id="ai_detector">
      <div className="p-3">
        <div className="container">
          <div style={{ marginTop: "6rem" }}>
            {/* Alert for failure */}
            <div
              className={`alert alert-${alert.type} ${
                alert.visible ? "" : "d-none"
              } fade show`}
              role="alert"
              style={{ marginTop: "5rem" }}
            >
              {alert.message}
            </div>

            <h1 className="display-6 text-center mt-2">
              Detect AI Generated Images / Photos
            </h1>
            <p className="text-center lead mt-4">
              An AI image detector is a tool that uses machine learning to
              identify whether an image has been created or manipulated by
              artificial intelligence. It helps detect deepfakes, verify image
              authenticity, and prevent the spread of misleading or synthetic
              content across digital platforms.
              <strong>
                This AI image detection tool is the best AI generated image
                detector available for free online.
              </strong>
            </p>

            {/* Upload Image */}
            <div className="container bg-light px-5 py-3 mt-5">
              {/* Upload iMage */}
              <h3 className="text-center lead mt-3">Upload Image</h3>
              <p className="text-muted text-center mb-5">
                Select image / photo you want to detect (.jpg, .png)
              </p>
              {/* Upload button displaying */}
              <div className="text-center">
                <button
                  className="btn btn-clear text-center"
                  type="button"
                  onClick={(e) => {
                    //blur
                    e.target.blur();
                    //call file select
                    fileInputRef.current.click();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="60"
                    fill="gray"
                    className="bi bi-upload"
                    viewBox="0 0 16 16"
                  >
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                    <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" />
                  </svg>
                </button>
                <p className="lead text-primary">
                  {aiImageDetectorValues.formFile === ""
                    ? "No file selected"
                    : aiImageDetectorValues.formFile.replace(/^.*[\\/]/, "")}
                </p>
              </div>

              {/* hidden button called after clicking on upload button */}
              <form onSubmit={onSubmitAIImageDetectorForm}>
                {/* Select File Button */}
                <div className="mb-3 mt-5">
                  <input
                    className="form-control d-none"
                    ref={fileInputRef} // Use a ref to access this element
                    type="file"
                    id="formFile"
                    accept="image/*"
                    onChange={onChangeAIImageDetectorForm}
                  />
                </div>

                {/* Analyze Image button */}
                <div className="text-center mt-5 justify-content-center d-flex">
                  <div
                    className={`spinner-border text-dark me-3 align-self-center ${
                      submitClicked ? "visible" : "invisible"
                    }`}
                    role="status"
                  >
                    <span className="sr-only"></span>
                  </div>
                  <button
                    className="btn btn-success px-4 py-3 fs-5"
                    type="submit"
                    style={{
                      backgroundColor: submitClicked
                        ? "#6c757d"
                        : ThemeButtonBGAIDetector,
                    }}
                    onClick={(e) => {
                      //blur
                      e.currentTarget.blur();
                    }}
                  >
                    <i className="bi bi-card-image me-3"></i>
                    Analyze Image
                  </button>
                </div>
              </form>

              {/* Selected Image */}
              <div
                className={`container text-center justify-content-center mt-5 ${
                  submitClicked ? "" : "d-none"
                }`}
              >
                <img
                  alt=""
                  className="rounded carousel-fade"
                  src={`${
                    aiImageDetectorValues.image_data === ""
                      ? null
                      : aiImageDetectorValues.image_data
                  }`}
                  style={{ width: "140px", height: "140px" }}
                ></img>
                <p className="mt-4 text-muted">
                  Please wait a moment while we analyze your image to determine
                  if it was generated by any artificial intelligence software.
                  This may take up to 2 minutes. Thank you for your patience.
                </p>
              </div>

              {/* Result */}
              <div
                className={`text-center mt-5 ${
                  aiImageDetectorValues.isLoaded ? "" : "d-none"
                }`}
              >
                {/* Horizontal line */}
                <hr />
                <p className="text-muted text-start">
                  AI image detection result:
                </p>
                {/* Image */}
                <img
                  alt=""
                  className="rounded carousel-fade"
                  src={`${
                    aiImageDetectorValues.image_data === ""
                      ? null
                      : aiImageDetectorValues.image_data
                  }`}
                  style={{ width: "140px", height: "140px" }}
                ></img>
                {/*Show gemerated by*/}
                <h3 className="text-dark mb-5 mt-5">
                  Your image is{" "}
                  <span
                    className={`fs-1 ${
                      aiImageDetectorValues.probability > 0.5
                        ? "text-danger"
                        : "text-success"
                    }`}
                  >
                    {aiImageDetectorValues.probability > 0.5
                      ? (aiImageDetectorValues.probability * 100).toFixed(2) +
                        "%"
                      : ((1 - aiImageDetectorValues.probability) * 100).toFixed(
                          2
                        ) + "%"}
                  </span>{" "}
                  {aiImageDetectorValues.probability > 0.5
                    ? " AI generated"
                    : " human captured"}{" "}
                  {aiImageDetectorValues.probability > 0.5 ? (
                    <i className="bi bi-laptop-fill ms-4 text-danger"></i>
                  ) : (
                    <i className="bi bi-camera-fill ms-4 text-success"></i>
                  )}
                </h3>

                {/* text */}
                <p
                  className={`text-muted ${
                    aiImageDetectorValues.probability > 0.5 ? "" : "d-none"
                  }`}
                >
                  Your image may be generated using ChatGPT, Gemini, Dall e,
                  Midjourney, Canva, Meta AI, Leonardo AI or any other AI image
                  generating softwares.
                </p>

                {/*Progress Bar*/}
                <div className="progress mx-5 mt-2">
                  <div
                    className={`progress-bar progress-bar-striped progress-bar-animated ${
                      aiImageDetectorValues.probability > 0.5
                        ? "bg-danger"
                        : "bg-success"
                    }`}
                    role="progressbar"
                    style={{
                      width: `${
                        aiImageDetectorValues.probability > 0.5
                          ? aiImageDetectorValues.probability * 100
                          : (1 - aiImageDetectorValues.probability) * 100
                      }%`,
                    }}
                    aria-valuenow={
                      aiImageDetectorValues.probability > 0.5
                        ? aiImageDetectorValues.probability * 100
                        : (1 - aiImageDetectorValues.probability) * 100
                    }
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                {/* Note */}
                <h5>
                  <p className="lead text-muted mt-5 fs-6 text-center">
                    Note: Our AI image detector identifies images that may have
                    been generated by artificial intelligence. Use your own
                    judgment when interpreting the results, and never rely
                    solely on AI image detection to make decisions that could
                    affect someone's academic or professional future.
                  </p>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AIImageDetector;
